import Api from 'services/Api';

export const getLive = (args) => (dispatch) => Api.actions.live.list(args)(dispatch);
